import { IAction } from "../../../interface/action.interface";
import { IErrorDto } from "../../../interface/dto/error.dto";
import {
    IListBuilderDetailsDto,
    IListBuilderDetailsBodyDto,
} from "../interface/dto/list-builder-details.dto";

export enum ListBuilderActionType {
    LIST_BUILDER_INIT = "LIST_BUILDER_INIT",
    LIST_BUILDER_GET_DETAILS = "LIST_BUILDER_GET_DETAILS",
    LIST_BUILDER_GET_DETAILS_SUCCESS = "LIST_BUILDER_GET_DETAILS_SUCCESS",
    LIST_BUILDER_GET_DETAILS_ERROR = "LIST_BUILDER_GET_DETAILS_ERROR",
    LIST_BUILDER_SAVE = "LIST_BUILDER_SAVE",
    LIST_BUILDER_SAVE_SUCCESS = "LIST_BUILDER_SAVE_SUCCESS",
    LIST_BUILDER_SAVE_ERROR = "LIST_BUILDER_SAVE_ERROR",
    LIST_BUILDER_RESET_SAVE_FLAG = "LIST_BUILDER_RESET_SAVE_FLAG",
}

export interface IListBuilderInitAction extends IAction {
    type: ListBuilderActionType.LIST_BUILDER_INIT;
}

export interface IListBuilderResetSaveFlagAction extends IAction {
    type: ListBuilderActionType.LIST_BUILDER_RESET_SAVE_FLAG;
}

export interface IListBuilderGetDetailsAction extends IAction {
    type: ListBuilderActionType.LIST_BUILDER_GET_DETAILS;
    payload: {
        listBuilderId: number;
    };
}

export interface IListBuilderGetDetailsSuccessAction extends IAction {
    type: ListBuilderActionType.LIST_BUILDER_GET_DETAILS_SUCCESS;
    payload: IListBuilderDetailsDto;
}

export interface IListBuilderGetDetailsErrorAction extends IAction {
    type: ListBuilderActionType.LIST_BUILDER_GET_DETAILS_ERROR;
    payload: {
        error: string;
    };
}

export interface IListBuilderSaveAction extends IAction {
    type: ListBuilderActionType.LIST_BUILDER_SAVE;
    payload: {
        listBuilder: IListBuilderDetailsBodyDto;
        run?: boolean;
        listBuilderId?: number;
    };
}

export interface IListBuilderSaveSuccessAction extends IAction {
    type: ListBuilderActionType.LIST_BUILDER_SAVE_SUCCESS;
}

export interface IListBuilderSaveErrorAction extends IAction {
    type: ListBuilderActionType.LIST_BUILDER_SAVE_ERROR;
    payload: {
        error: IErrorDto;
    };
}

export const resetSaveFlagAction = (): IListBuilderResetSaveFlagAction => ({
    type: ListBuilderActionType.LIST_BUILDER_RESET_SAVE_FLAG,
    payload: undefined,
});

export const listBuilderInitAction = () => ({
    type: ListBuilderActionType.LIST_BUILDER_INIT,
});

export const listBuilderGetDetailsAction = (
    listBuilderId: number,
): IListBuilderGetDetailsAction => ({
    type: ListBuilderActionType.LIST_BUILDER_GET_DETAILS,
    payload: {
        listBuilderId,
    },
});

export const listBuilderGetDetailsSuccessAction = (
    listBuilderDetails: IListBuilderDetailsDto,
): IListBuilderGetDetailsSuccessAction => ({
    type: ListBuilderActionType.LIST_BUILDER_GET_DETAILS_SUCCESS,
    payload: listBuilderDetails,
});

export const listBuilderGetDetailsErrorAction = (
    error: string,
): IListBuilderGetDetailsErrorAction => ({
    type: ListBuilderActionType.LIST_BUILDER_GET_DETAILS_ERROR,
    payload: { error },
});

export const listBuilderSaveAction = (
    listBuilder: IListBuilderDetailsBodyDto,
    run?: boolean,
    listBuilderId?: number,
): IListBuilderSaveAction => ({
    type: ListBuilderActionType.LIST_BUILDER_SAVE,
    payload: {
        listBuilderId,
        listBuilder,
        run,
    },
});

export const listBuilderSaveSuccessAction =
    (): IListBuilderSaveSuccessAction => ({
        type: ListBuilderActionType.LIST_BUILDER_SAVE_SUCCESS,
        payload: {},
    });

export const listBuilderSaveErrorAction = (
    error: IErrorDto,
): IListBuilderSaveErrorAction => ({
    type: ListBuilderActionType.LIST_BUILDER_SAVE_ERROR,
    payload: { error },
});

export type IListBuilderActions =
    | IListBuilderInitAction
    | IListBuilderGetDetailsAction
    | IListBuilderGetDetailsSuccessAction
    | IListBuilderGetDetailsErrorAction
    | IListBuilderSaveAction
    | IListBuilderSaveSuccessAction
    | IListBuilderSaveErrorAction
    | IListBuilderResetSaveFlagAction;
